import styled from 'styled-components';
import colors from 'constants/colors';

const Row = styled.div`
  padding-left: 20px;
  display: flex;
  border-bottom: 1px solid ${colors.main.disabledBtns};

  &:first-child {
    border-top: 1px solid ${colors.main.disabledBtns};
  }

  @media screen and (max-width: 992px) {
    padding: 0;
  }
`;

export default Row;
